:host {
  --background-base-color: color-mix(in srgb, var(--pos-background-color), var(--color-grey-800) 10%);
  --background-color-even: hsl(from var(--background-base-color) h s calc(l + 7));
  --background-color-odd: hsl(from var(--background-base-color) h s calc(l + 10));
  --border-color: var(--background-base-color);
}

ul {
  display: flex;
  flex-direction: column;
  gap: var(--size-2);

  margin: 0;
  padding: 0;

  li {
    border: var(--size-px) solid var(--border-color);
    &:nth-child(even) {
      background-color: var(--background-color-even);
    }
    &:nth-child(odd) {
      background-color: var(--background-color-odd);
    }
    padding: var(--size-4);
    list-style-type: none;
  }
}
